import { useEffect, useState } from "react";
import { useAppDispatch } from "../../app/store";
import { getDetalleDeCurso } from "../../features/Dashboard/AsyncThunks/cursos/getDetalleCurso";
import { useSelector } from "react-redux";
import { selectDetalleCurso, setCleanDetalleCurso } from "../../features/Dashboard/Slices/dashboardSlice";
import { InfoMirros } from "../../types";
import { parseHours } from "../../utils";
import JsonViewer from "../../components/reusable/JsonViewer/JsonViewer";
import TableList from "../../components/TableList/TableList";
import Input from "../../components/reusable/Input/Input";
import Label from "../../components/reusable/Label/Label";
import useAuth from "../../hooks/useAuth";

const formatFecha = (fecha: string | null | undefined) => {
  if (!fecha) return "-";
  const d = new Date(fecha);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString();
};

export default function Cursos() {
  const [loading, setLoading] = useState(false);
  const [idCurso, setIdCurso] = useState<string>("");
  const [anioLectivo, setAnioLectivo] = useState<string>("");
  const detalleCurso = useSelector(selectDetalleCurso);
  const { hasPermission } = useAuth();

  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   return () => {
  //     dispatch(setCleanDetalleCurso())
  //   }
  // }, [])
  

  const handleDetalleCurso = async (idCurso: number, anioLectivo: number) => {
    if (idCurso && anioLectivo) {
      setLoading(true);
      await dispatch(getDetalleDeCurso({ idCurso, anioLectivo }));
      //setIdCurso("");
      setLoading(false);
    } else {
      // toastInfo("Ingrese idCupo");
    }
  };

 const handleChangeIdCurso = (value: string) => {
   setIdCurso(value);
 };

 const handleChangeAnioLectivo = (value: string) => {
   setAnioLectivo(value);
 };

 const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
   event.preventDefault();
   const cursoId = Number(idCurso);
   const anioLectivoInput = Number(anioLectivo);
   if (cursoId > 0 && anioLectivoInput > 0) {
     handleDetalleCurso(cursoId, anioLectivoInput);
   } else {
     alert("ID de curso y año lectivo son requeridos");
   }
 };

  return (
    <div className="p-6 flex items-start gap-6">
      <div className="bg-white p-6 rounded-lg border-2 border-cardBorder w-3/4">
        <div className="flex items-center justify-between">
          <h4 className="font-semibold text-textSecondary mb-3 text-[16px]">
            Cursos
          </h4>
          <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
            <div className="flex gap-2 items-end">
              <div className="flex flex-col">
                <Label htmlFor="idCurso" required>
                  ID Curso
                </Label>
                <Input
                  value={idCurso}
                  onChange={handleChangeIdCurso}
                  type="text"
                  placeholder="Ingrese ID del curso"
                  onlyNumbers={true}
                  maxLength={10}
                  className="w-32"
                  disabled={!hasPermission("cursos", "buscar_curso")}
                />
              </div>
              <div className="flex flex-col">
                <Label htmlFor="anioLectivo" required>
                  Año Lectivo
                </Label>
                <Input
                  value={anioLectivo}
                  onChange={handleChangeAnioLectivo}
                  type="text"
                  placeholder="Ej: 2024"
                  onlyNumbers={true}
                  maxLength={4}
                  className="w-32"
                  disabled={!hasPermission("cursos", "buscar_curso")}
                />
              </div>
              <button
                type="submit"
                className="px-4 py-2 text-white bg-primary rounded-md disabled:opacity-50 disabled:cursor-not-allowed h-10"
                disabled={!hasPermission("cursos", "buscar_curso")}
              >
                Buscar
              </button>
            </div>
          </form>
        </div>

        {detalleCurso && (
          <div className="border-[1px] border-secondary p-3 my-4 space-y-4">
            {/* --------------------------------- titulo ---------------------------------  */}
            <div className="col-span-4 bg-[#eee] flex justify-between p-2">
              <h3 className="font-semibold text-[14px]">
                <span className="text-secondary font-normal mr-3">
                  #{detalleCurso?.curso.N_CURSO}
                </span>
                {detalleCurso?.curso.D_DESCRIP}
              </h3>
              <h3 className="font-semibold text-[14px]">
                <span className="ml-4 text-secondary font-normal">Tipo de periodo </span>
                {detalleCurso?.curso.C_TIPO_PERIODO}
              </h3>
              <h3 className="font-semibold text-[14px]">
                <span className="ml-4 text-secondary font-normal">Periodo </span>
                {detalleCurso?.curso.N_PERIODO}
              </h3>
              <h3 className="font-semibold text-[14px]">
                <span className="ml-4 text-secondary font-normal">Año </span>
                {detalleCurso?.curso.C_AÑO_LECTIVO}
              </h3>
            </div>

            {/*  --------------------------------- fechas ---------------------------------  */}
            <div className="">
              <h4 className="font-bold pb-2">Fechas</h4>
              <div className="flex justify-center items-center gap-6">
                <div className="flex-grow">
                  <p className="border-b-[1px] border-cardBorder">Fecha inicio</p>
                  <h5 className="">
                    {formatFecha(detalleCurso.curso.F_INICIO)}
                  </h5>
                </div>
                <div className="flex-grow">
                  <p className="border-b-[1px] border-cardBorder">Fecha cierre</p>
                  <h5 className="">
                    {formatFecha(detalleCurso.curso.F_CIERRE)}
                  </h5>
                </div>
                <div className="flex-grow">
                  <p className="border-b-[1px] border-cardBorder">Fecha hasta</p>
                  <h5 className="">
                    {formatFecha(detalleCurso.curso.F_FIN)}
                  </h5>
                </div>
                <div className="flex-grow">
                  <p className="border-b-[1px] border-cardBorder">Fecha alta</p>
                  <h5 className="">
                    {formatFecha(detalleCurso.curso.F_ALTA)}
                  </h5>
                </div>
                <div className="flex-grow">
                  <p className="border-b-[1px] border-cardBorder">Fecha actualización</p>
                  <h5 className="">
                    {formatFecha(detalleCurso.curso.F_ACTUALIZAC)}
                  </h5>
                </div>
                <div className="flex-grow">
                  <p className="border-b-[1px] border-cardBorder">Fecha comienzo</p>
                  <h5 className="">
                    {formatFecha(detalleCurso.curso.F_COMIENZO)}
                  </h5>
                </div>
              </div>
            </div>

            {/*  ------------------------------ observaciones -----------------------------  */}
            <div>
              <h4 className="font-bold pb-2">Observaciones</h4>
              <p className="px-3">
                {detalleCurso.curso.D_OBSERVACIONES
                  ? detalleCurso.curso.D_OBSERVACIONES
                  : "- sin observaciones -"}
              </p>
            </div>
            {/*  -------------------------------- horarios -------------------------------- */}
            <div>
              <h4 className="font-bold pb-2">Horarios</h4>
              <CursosHorarios horarios={detalleCurso.infoMirros} />
            </div>
            {/*  -------------------------------- cupos -------------------------------- */}
            <div>
              <h4 className="font-bold pb-2">Cupos</h4>
              <TableList list={detalleCurso.cupos} enableSearchbar={false} page="cursos" />
            </div>
          </div>
        )}
      </div>

      {detalleCurso?.kv && (
        <div className="w-1/4">
          <JsonViewer json={detalleCurso?.kv} />
        </div>
      )}
    </div>
  );
}

/* -------------------------------- HORARIOS -------------------------------- */
interface ICursosProps {
  horarios: InfoMirros[];
}
function CursosHorarios({ horarios }: ICursosProps) {
  return (
    <table className="table-auto w-full border-[1px] border-cardBorder border-collapse">
      <thead>
        <tr className="border-[1px] border-cardBorder">
          <th>ID</th>
          <th>Dia</th>
          <th>Tipo clase</th>
          <th>Desde</th>
          <th>Hasta</th>
          <th>Aula</th>
          <th>Profesor</th>
        </tr>
      </thead>
      <tbody>
        {horarios.map((horario) => (
          <tr className="border-[1px] border-cardBorder">
            <td className="p-1">{horario.N_ID_HORARIO}</td>
            <td className="p-1">{horario.C_DIA_SEMANAL}</td>
            <td className="p-1">{horario.C_TIPO_CLASE}</td>
            <td className="p-1">{parseHours(horario.C_HORA_DESDE)} hs</td>
            <td className="p-1">{parseHours(horario.C_HORA_HASTA)} hs</td>
            <td className="p-1">{horario.AULA}</td>
            <td className="p-1">
              {horario.APELLIDO_PROFESOR},{horario.NOMBRE_PROFESOR} (
              {horario.C_ROL})
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
